import {
  ActivityTableItem,
  PublicBookmark,
} from './activity_table_item.wjs.jsx';
import { UserCard } from 'js/academia_components/cards/user_card';
import { connect } from 'react-redux';
import _ from 'underscore';

const MainTable = ({ title, children }) => {
  if (_.isEmpty(children)) return null;

  return (
    <div className="wp-usercard-main responsive_margins">
      <div className="wp-usercard-main__title">{title}</div>
      <table className="wp-usercard-main__table">
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};

export const ReaderCard = ({
  read_events,
  reader,
  recent_activity,
  anon = false,
  onProfileClick = undefined,
  onTitleClick = undefined,
}) => {
  const titleClickHandler = (linkType, entityId) =>
    onTitleClick ? () => onTitleClick(linkType, entityId) : undefined;

  return (
    <UserCard anon={anon} user={reader} onProfileClick={onProfileClick}>
      <div>
        <MainTable title="Recent Activity">
          {/* NATIONAL PARKS: Please remove this disable and try to fix it if you're here */}
          {/* eslint-disable-next-line @typescript-eslint/no-unused-vars */}
          {read_events.map(({ id, ...props }, index) => (
            <ActivityTableItem
              {...props}
              key={index}
              onTitleClick={titleClickHandler(
                props.type === 'profile_view' ? 'profile' : 'paper',
                Number.isInteger(props.work?.id) ? props.work.id : undefined,
              )}
            />
          ))}
        </MainTable>
        <MainTable title="Recently Bookmarked">
          {recent_activity.map(({ work_title, url, work_authors }, index) => (
            <PublicBookmark
              key={index}
              type="bookmark"
              title={work_title}
              url={url}
              authors={work_authors}
              onTitleClick={titleClickHandler('paper')}
            />
          ))}
        </MainTable>
      </div>
    </UserCard>
  );
};

const mapStateToProps = ({ ReaderCards }, { id }) => ({
  anon: ReaderCards.models[id].reader.anonymous,
  reader: ReaderCards.models[id].reader,
  read_events: ReaderCards.models[id].read_events,
  recent_activity: ReaderCards.models[id].recent_activity,
});

export const ConnectedReaderCard = connect(mapStateToProps)(ReaderCard);
